export function getThirdLevelIds(tree, targetId) {
    if (!tree || !Array.isArray(tree) || !targetId) {
        return [];
    }

    var result = [];

    function dfs(nodes) {
        for (const node of nodes) {
            if (String(node.id) === String(targetId)) {
                collectThirdLevel(node);
                return;
            }

            if (node.children && Array.isArray(node.children)) {
                dfs(node.children);
            }
        }
    }

    function collectThirdLevel(node) {
        if (node.children && node.children.length > 0) {

            for (const child of node.children) {
                if (child.children && child.children.length > 0 && Array.isArray(child.children)) {
                    child.children.forEach(grandChild => {
                        result.push(grandChild.id);
                    });
                } else {
                    result.push(child.id);
                }
            }
        }else
        {
            result.push(node.id);
        }
    }

    dfs(tree);
    return result;
}

export function getAncestorPath(tree, targetId) {
  if (!tree || !Array.isArray(tree) || !targetId) {
    return [];
  }

  const result = [];

  function findPath(nodes) {
    for (const node of nodes) {
      result.push(node.id);

      if (String(node.id) === String(targetId)) {
        return true;
      }

      if (node.children && Array.isArray(node.children)) {
        if (findPath(node.children)) {
          return true;
        }
      }

      result.pop();
    }

    return false;
  }

  findPath(tree);
  return result;
}

// 只获取上级ID（不包括目标节点本身）
export function getAncestorIds(tree, targetId) {
  if (!tree || !Array.isArray(tree) || !targetId) {
    return [];
  }

  const result = [];

  function findPath(nodes) {
    for (const node of nodes) {
      // 先添加到路径中
      result.push(node.id);

      if (String(node.id) === String(targetId)) {
        // 找到目标节点，移除它本身，只保留上级ID
        result.pop();
        return true;
      }

      if (node.children && Array.isArray(node.children)) {
        if (findPath(node.children)) {
          return true;
        }
      }

      // 如果没找到，移除当前节点
      result.pop();
    }

    return false;
  }

  findPath(tree);
  return result;
}